import styled, { Theme } from '@mint-lib/styled';
import { SxProps } from '@mui/material/styles';

import IconButton from '../IconButton/IconButton.jsx';
import TableHeaderCell from '../TableHeaderCell/TableHeaderCell.jsx';

export interface TableHeaderCellExpanderProps {
  expanded?: boolean;
  onExpand?: () => void;
  sx?: SxProps<Theme>;
  display?: boolean;
}

const TableHeaderCellExpander = ({
  expanded,
  onExpand,
  sx,
  display = true,
}: TableHeaderCellExpanderProps) => {
  return (
    <Container sx={sx}>
      {display ? (
        <IconButton
          aria-label="expand-button"
          color="secondary"
          variant="icon"
          size="medium"
          icon={expanded ? 'ExpandRows' : 'CollapseRows'}
          onClick={onExpand}
          sx={{
            marginLeft: '4px',
          }}
        />
      ) : null}
    </Container>
  );
};

export default TableHeaderCellExpander;

const Container = styled(TableHeaderCell)(({ theme }) => ({
  backgroundColor: theme.palette.ui.primary,
  width: '40px',
  height: '40px',
  padding: 0,
}));
